export default "__VITE_ASSET__a306b801__"